import 'jquery-ui/ui/widgets/draggable';
import Scrollbar from './elements/scrollbar';
import screen from './modules/screen';
import Scroller from './modules/scroller';
import NavIndicator from './modules/indicator';
import menu from './modules/menu';
import SVG from 'svg.js';
import './modules/count';
import './modules/fs2';

function getIE() {
  var sAgent = window.navigator.userAgent;
  var Idx = sAgent.indexOf("MSIE");
  if (Idx > 0)
  return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));
  else if (!navigator.userAgent.match(/Trident\/7\./))
  return 11;
  else
  return 0;
}

$(document).ready(function()
{
  /* Global wrapper */
  let wrapper = $('.wrapper'),
  homePage = $('.page--home'),
  creditsPage = $('.page--credits');

  /* Prevent clicks on empty links */
  $("body").on("click", "a[href='#']", function(){
    return false;
  });

  /* Scrollable */
  new Scrollbar('.scrollable');

  /* Faits saillants #2 */
  let fs2 = $('.fs2').FS_Graphics();

  function shuffleArray(a) {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  /* Give it a few seconds */
  setTimeout(function(){
    $('.page--home .arrow').addClass('visible');
  }, 10000);

  var AllColors = ['#B2D235', '#3BBEC4', '#F9A01B', '#FFCE00', '#0083CA'];
  var CirclesIntersection = function(a_circle, b_circle, distance, colors) {
    let circle_a = a_circle;
    let circle_b = b_circle;
    if (distance < circle_a.width() * 3 / 4 || distance < circle_b.width() * 3 / 4) {
      if (circle_a.contact.indexOf(circle_b) === -1) {
        circle_a.contact.push(circle_b);
        colors.splice(colors.indexOf(circle_a.color), 1);
        colors.splice(colors.indexOf(circle_b.color), 1);
        colors = shuffleArray(colors);
        let color_a = colors[0], color_b = colors[1];

        if (!circle_a.t_animating) {
          circle_a.t_animating = true;
          circle_a.opacity(0.9);
          circle_a.stop(false, true);
          circle_a.animate(500).fill({color: color_a}).animate(7500).size(50 + Math.round(Math.random() * 90));
          let targetSpeedX = circle_a.speedX + (Math.random() * 0.75 + 0.5) * (circle_a.x() < circle_b.x() ? -1 : 1);
          if (targetSpeedX > 2) targetSpeedX = 2;
          if (targetSpeedX < -2) targetSpeedX = -2;
          if (targetSpeedX >= 0 && targetSpeedX < 1) targetSpeedX = 1;
          if (targetSpeedX < 0 && targetSpeedX > -1) targetSpeedX = -1;
          let targetSpeedY = circle_a.speedY + (Math.random() * 0.75 + 0.5) * (circle_a.y() < circle_b.y() ? -1 : 1);
          if (targetSpeedY > 2) targetSpeedY = 2;
          if (targetSpeedY < -2) targetSpeedY = -2;
          if (targetSpeedY >= 0 && targetSpeedY < 1) targetSpeedY = 1;
          if (targetSpeedY < 0 && targetSpeedY > -1) targetSpeedY = -1;

          // tween
          let a_intervalStartX = circle_a.speedX;
          let a_intervalStartY = circle_a.speedY;
          let a_intervalValueX = (targetSpeedX - a_intervalStartX) / 15;
          let a_intervalValueY = (targetSpeedY - a_intervalStartY) / 15;
          let a_intervalCounter = 0;
          let a_interval = setInterval(function() {
            a_intervalCounter += 1;
            if (a_intervalCounter >= 15) {
              circle_a.t_animating = false;
              clearInterval(a_interval);
            }
            circle_a.speedX = a_intervalStartX + (a_intervalValueX * a_intervalCounter);
            circle_a.speedY = a_intervalStartY + (a_intervalValueY * a_intervalCounter);
          }, 60)
        }

        if (!circle_b.t_animating) {
          circle_b.t_animating = true;
          circle_b.opacity(0.9);
          circle_b.stop(false, true);
          circle_b.animate(500).fill({color: color_b}).animate(7500).size(50 + Math.round(Math.random() * 90));
          let targetSpeedX = circle_b.speedX + (Math.random() * 0.75 + 0.5) * (circle_b.x() < circle_a.x() ? -1 : 1);
          if (targetSpeedX > 2) targetSpeedX = 2;
          if (targetSpeedX < -2) targetSpeedX = -2;
          if (targetSpeedX >= 0 && targetSpeedX < 1) targetSpeedX = 1;
          if (targetSpeedX < 0 && targetSpeedX > -1) targetSpeedX = -1;
          let targetSpeedY = circle_b.speedY + (Math.random() * 0.75 + 0.5) * (circle_b.y() < circle_a.y() ? -1 : 1);
          if (targetSpeedY > 2) targetSpeedY = 2;
          if (targetSpeedY < -2) targetSpeedY = -2;
          if (targetSpeedY >= 0 && targetSpeedY < 1) targetSpeedY = 1;
          if (targetSpeedY < 0 && targetSpeedY > -1) targetSpeedY = -1;

          // tween
          let b_intervalStartX = circle_b.speedX;
          let b_intervalStartY = circle_b.speedY;
          let b_intervalValueX = (targetSpeedX - b_intervalStartX) / 15;
          let b_intervalValueY = (targetSpeedY - b_intervalStartY) / 15;
          let b_intervalCounter = 0;
          let b_interval = setInterval(function() {
            b_intervalCounter += 1;
            if (b_intervalCounter >= 15) {
              circle_b.t_animating = false;
              clearInterval(b_interval);
            }
            circle_b.speedX = b_intervalStartX + (b_intervalValueX * b_intervalCounter);
            circle_b.speedY = b_intervalStartY + (b_intervalValueY * b_intervalCounter);
          }, 60)
        }
      }
    } else {
      if (circle_a.contact.indexOf(circle_b) !== -1) {
        circle_a.contact.splice(circle_a.contact.indexOf(circle_b), 1);
        circle_b.contact.splice(circle_b.contact.indexOf(circle_a), 1);
      }
    }
  }

  /* Triangles animation */
  var RunAnimation = function (section) {
    var circles = [];

    section.find('.animation').each(function() {
      /* Prepare view box */
      let windowWidth = $(window).width(), windowHeight = $(window).height();
      $(this).find('svg').attr('viewBox', '0 0 ' + windowWidth + ' ' + windowHeight);
      $(this).find('svg').attr('enable-background', '0 0 ' + windowWidth + ' ' + windowHeight);
      $(window).on('resize load orientationchange', function() {
        let windowWidth = $(window).width(), windowHeight = $(window).height();
        $(this).find('svg').attr('viewBox', '0 0 ' + windowWidth + ' ' + windowHeight);
        $(this).find('svg').attr('enable-background', '0 0 ' + windowWidth + ' ' + windowHeight);
      });
      $(this).show();

      /* Prepare circles */
      for (var i = 1; i <= 12; i++) {
        let circle = SVG.get("c" + i);
        circle.opacity(0);
        circle.t_animating = false;
        circle.index = i;
        circle.cx(Math.random() * windowWidth).cy(Math.random() * windowHeight);
        circle.size(50 + Math.round(Math.random() * 90));
        circle.speedX = (Math.random() * 1 + 1) * (Math.random() < 0.5 ? -1 : 1);
        circle.speedY = (Math.random() * 1 + 1) * (Math.random() < 0.5 ? -1 : 1);
        circle.color = circle.attr('fill');
        circle.animate(500).opacity(0.9);
        circle.contact = [];
        circles.push(circle);
      }

      /* Prepare circles */
      for (var h = 13; h <= 15; h++) {
        let circle = SVG.get("c" + h);
        circle.hide();
      }

      /* Animation frame */
      var onEnterFrame = function() {
        circles.forEach(function(circle) {
          /* Move circles */
          circle.dmove(circle.speedX, circle.speedY);
          if (circle.cx() < -circle.width() / 2) {
            circle.cx($(window).width() + circle.width() / 2);
          } else if (circle.cx() > $(window).width() + circle.width() / 2) {
            circle.cx(-circle.width() / 2);
          }
          if (circle.cy() < -circle.height() / 2) {
            circle.cy(windowHeight + circle.height() / 2);
          } else if (circle.cy() > windowHeight + circle.height() / 2) {
            circle.cy(-circle.height() / 2);
          }
        });

        /* Check for intersection */
        for (var i = 0; i < circles.length; i++) {
          var circle_a = circles[i];
          for (var z = i + 1; z < circles.length; z++) {
            var circle_b = circles[z];
            var distance = Math.hypot(circle_a.cx() - circle_b.cx(), circle_b.cy() - circle_a.cy());
            CirclesIntersection(circle_a, circle_b, distance, AllColors.slice(0));
          }
        }
        window.requestAnimationFrame(onEnterFrame);
      }
      window.requestAnimationFrame(onEnterFrame);
    });
  }

  /* Links that open article */
  $('.article-controller[aria-controls]').on("click", function(){
    let targetSelector = "#" + $(this).attr("aria-controls"),
    targetControllers = '[aria-controls="' + $(this).attr("aria-controls") + '"]';
    if ($(this).attr("aria-expanded") == "true"){
      $(targetSelector).attr("aria-hidden", "true");
      $(targetControllers).attr("aria-expanded", "false");
      navIndicator.setCurrentStage(wrapperScroller);
      sectionChanged();
    } else {
      $(targetSelector).attr("aria-hidden", "false");
      $(targetControllers).attr("aria-expanded", "true");
      let overScroller = overScrollers[$(this).attr("aria-controls")];
      overScroller.scrollTo($(this).attr("href"));
      navIndicator.setCurrentStage(overScroller);
      sectionChanged();
    }

    /* Close main menu */
    if ($("#main-menu").attr("aria-hidden") == "false"){
      $('#main-menu .close button').click();
      navIndicator.setCurrentStage(wrapperScroller);
      sectionChanged();
    }

    /* Do not show anchor */
    return false;
  });

  /* Screen height fix */
  if (getIE() > 0){
    screen.init({
      selector: '.screen-height, .screen:not(.auto-height)',
      inner: '.screen-content, .screen__content',
    });
  }

  /* Scroll management */
  let wrapperScroller = new Scroller('.wrapper > .scroller');
  wrapperScroller.init();
  wrapperScroller.scroller.on("currentSection", sectionChanged);
  wrapperScroller.scroller.on('screen', function(event, status){
    if (status.hasArrivedAtLastScreen){
      creditsPage.append($('.language, .burger').hide().fadeIn(200));
    } else if (status.hasScrolledPastFirstScreen){
      wrapper.before($('.language, .burger').hide().fadeIn(200));
      $('.page--home .arrow').addClass('has-scrolled');
    } else {
      homePage.find('.page__header').append($('.language, .burger').hide().fadeIn(200));
    }
  });
  homePage.find('.page__header').append($('.language, .burger').hide().fadeIn(200));

  /* Scroll management for overlay articles */
  var overScrollers = {};
  $(".over").each(function(){
    let overScrollerElement = $(this).find(".scroller").get(0);
    let overScroller = new Scroller(overScrollerElement);
    overScroller.init();
    overScroller.scroller.on("currentSection", sectionChanged);
    overScroller.scroller.on("scrolled", function(){
      $(this).closest('.over').addClass('has-scrolled');
    });
    overScrollers[$(this).attr("id")] = overScroller;
  });

  /* Nav indicator */
  var navIndicator = new NavIndicator('.indicator');
  navIndicator.init();
  navIndicator.setCurrentStage(wrapperScroller);
  sectionChanged();

  /* Menu open and close */
  menu.init();

  /* Counts */
  $('.count').each(function(){
    $(this).data('count', $(this).Count());
  });

  /* Card that scrolls to subsection */
  $('.over a[href^="#subsection"]').on("click", function(){
    let currentStage = $(this).closest('.scroller'),
    scrollTop = currentStage.scrollTop(),
    targetTop = $($(this).attr("href")).offset().top + scrollTop,
    distance = Math.abs(targetTop - scrollTop);
    currentStage.animate({
      scrollTop: targetTop + 'px',
    }, 500 + distance / 5, 'swing');
    return false;
  });

  /* Bullet that scrolls to subsection */
  $('body').on("click", '.bullet', function(){
    if ($(this).hasClass("bullet--current")) return false;
    let currentStage = navIndicator.getCurrentStage(),
    scrollTop = currentStage.scroller.scrollTop(),
    targetTop = currentStage.scroller.find(".article__subsection").eq($(this).index()).offset().top + scrollTop,
    distance = Math.abs(targetTop - scrollTop);
    currentStage.scroller.animate({
      scrollTop: targetTop + 'px',
    }, 500 + distance / 5, 'swing');
    return false;
  });

  /* Count timeout objects */
  let countTimeout = undefined;

  /* Section changed */
  function sectionChanged() {
    // Add "appear" class
    var currentSection = $(navIndicator.getCurrentStage().getCurrentSection());
    currentSection.addClass("appear");

    // Circles animation
    if (currentSection.hasClass('page--home')/* || currentSection.hasClass('page--credits')*/){
      if (!currentSection.data('runAnimation')){
        let runAnimation = new RunAnimation(currentSection);
        currentSection.data('runAnimation', runAnimation);
      }
    }

    // Count animations
    clearTimeout(countTimeout);
    countTimeout = setTimeout(function()
    {
      // Count animations
      currentSection.find('.count').each(function(){
        let countModule = $(this).data('count');
        countModule.run();
      });

      // FS2 animation
      if (currentSection.find('.fs2').length){
        fs2.run();
      }
    }, 125);
  }

  /* SVG triangles */
  $('.screen--section-intro').each(function(){
    let triangle = $('#section-01 .triangle');
    if ($(this).data("index") != "01"){
      $(this).append(triangle.clone());
    }
  });
  $('.over').each(function(){
    let triangle = $('#subsection-1 .triangle'),
    arrowUp = $('#subsection-1 .arrow-up'),
    arrowDown = $('#subsection-1 .arrow-down');
    if ($(this).data("index") != "01"){
      $(this).append(triangle.clone());
      $(this).append(arrowUp.clone());
      $(this).append(arrowDown.clone());
    }
  });
});
